import { useEffect } from "react";
import HeroSection from "./components/HeroSection";
import FeaturedCreatorsSection from "./components/FeaturedCreatorsSection";
import CategoriesSection from "./components/CategoriesSection";
import FacebookGroupsSection from "./components/FacebookGroupsSection";
import ForumsPreviewSection from "./components/ForumsPreviewSection";
import CtaSection from "./components/CtaSection";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://example.com";

export default function HomePage() {
  useEffect(() => {
    document.title = "Junk & Post — Junk Journal & Snail Mail Creator Directory";
    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", "Discover 500+ junk journal and snail mail creators. Browse handmade ephemera, washi tape, stamps, stickers, and snail mail kits. The definitive directory for paper crafting enthusiasts.");
    setMeta("og:title", "Junk & Post — Junk Journal & Snail Mail Creator Directory", true);
    setMeta("og:description", "Discover 500+ junk journal and snail mail creators. Browse handmade ephemera, washi tape, stamps, stickers, and snail mail kits.", true);
    setMeta("og:url", `${SITE_URL}/`, true);

    // Schema.org JSON-LD
    const existing = document.getElementById("schema-home");
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.id = "schema-home";
    script.type = "application/ld+json";
    script.text = JSON.stringify([
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Junk & Post",
        "url": SITE_URL,
        "description": "The definitive directory for junk journal and snail mail creators. Discover handmade ephemera, washi tape, stamps, stickers, and snail mail kits.",
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": `${SITE_URL}/catalog?q={search_term_string}`
          },
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Junk & Post",
        "url": SITE_URL,
        "description": "The definitive directory for junk journal and snail mail creators.",
        "sameAs": []
      }
    ]);
    document.head.appendChild(script);

    return () => {
      document.getElementById("schema-home")?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <FeaturedCreatorsSection />
      <CategoriesSection />
      <FacebookGroupsSection />
      <ForumsPreviewSection />
      <CtaSection />
      <Footer />
    </div>
  );
}
